import { MenuItemLink as RaMenuItemLink, type MenuItemLinkProps } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { MENU_ITEM_SUPPRESSED_CLASS, isSuppressedRoute } from './menuRoutes';
import { useIsInsideFlyout } from './SubMenu/FlyoutContext';

export { MENU_ITEM_SUPPRESSED_CLASS };

/**
 * `MenuItemLink` do react-admin com duas correções:
 *
 *  1. um item para de acender quando a URL atual pertence a um item mais
 *     específico do menu (a regra está em `menuRoutes.ts`);
 *  2. dentro do painel flutuante do submenu o tooltip não aparece — o
 *     react-admin o liga sempre que a barra está recolhida, e ali o rótulo já
 *     está escrito ao lado do ícone.
 *
 * O resto das props passa direto.
 */
const MenuItemLink = ({ className, ...props }: MenuItemLinkProps) => {
  const { pathname } = useLocation();
  const insideFlyout = useIsInsideFlyout();

  const to = typeof props.to === 'string' ? props.to : props.to?.pathname ?? '';
  const isSuppressed = isSuppressedRoute(pathname, to);

  const mergedClassName = [className, isSuppressed ? MENU_ITEM_SUPPRESSED_CLASS : null]
    .filter(Boolean)
    .join(' ');

  const tooltipProps = insideFlyout
    ? {
      ...props.tooltipProps,
      disableHoverListener: true,
      disableFocusListener: true,
      disableTouchListener: true,
    }
    : props.tooltipProps;

  return (
    <RaMenuItemLink
      {...props}
      tooltipProps={tooltipProps}
      className={mergedClassName || undefined}
    />
  );
};

export default MenuItemLink;
